export const HEADER_CONTENT_ACCEPT_JSON = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

export const TENANT_API = {
  INFO: "tenant/info",
};

export const BUSINESS_API = {
  INFO: "business",
};

export const SETTINGS_API = {
    INFO: "settings",
    LOCALNOW: "settings/localNow"
}

export const LOGIN_API = {
  LOGIN: "login",
};

export const TRANSLATION_API = {
  LIST: "translations/#LANG#",
};

export const TRADER_API = {
  LIST: "traders",
};

export const STANDINGORDER_API = {
  LIST: "standingorders",
  GET_DETAILS:
    // "standingOrder/getStandingOrderDetails/?date=#DATE#&addressId=#ADDRESSID#",
    "standingOrder/getStandingOrderDetails/?addressId=#ADDRESSID#",
  SAVE_SO: "standingOrder/SaveStandingOrders",
};

export const STANDINGORDERITEM_API = {
  LIST: "standingOrder/items/#ADDRESSID#",
};

export const ITEM_API = {
  LIST: "traders/items",
  LIST_BY_ADDRESS_AND_DATE:
    "cart/items/#ADDRESSID#/#DATE#/#ISSAMEDAYORDER#/#ITEMNAME#",
  DETAIL: "item/details/#ITEMID#",
};

export const CART_API = {
  CART_DEFAULT_ADDRESSID: "cart/defaultAddressId",
  CART_AVAIL_DATE_BY_ADDRESS: "cart/firstAvailableDate/#ADDRESSID#",
  GET_CART: "cart/#ADDRESSID#/#DATE#/#SOAMMEND#/#ISSAMEDAYORDER#/#ISLATE#/#SEQUENCE#/#ID#",
  GET_CARTS: "cart/list/#ADDRESSID#/#DATE#",
  PLACE_CART: "cart",
  FUTURE_ORDERS: "cart/futureOrders/#ADDRESSID#",
  DELETE_CART: "cart/deleteCart",
  CANCEL_SOCART: "cart/cancelSOrder",
  CART_VALIDATE_DATES: "cart/validateDates/#ADDRESSID#/#FROM#/#TO#",
};

export const SAVED_CART_API = {
  LIST: "cart/savedCarts/#ADDRESSID#",
  SAVE: "cart/saveCartForLater",
};

export const ADDRESS_API = {
  PRICERULE: "address/priceRules/#ADDRESSID#",
  ADDRESS: "address/getAddress/#ADDRESSID#",
  ADDRESSES: "address/getAddressList/#TRADERID#",
};

export const IP_API = {
  IPAPI: "https://geolocation-db.com/json/",
};

export const INVITATION_API = {
  INVITE: "invitation/#ID#",
  SEND: "invitation",
};
